import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-fe682536"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "notice-content"
};
var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("section", {
    class: "notice-floor"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "content"
  }, " 欢迎参加本活动。请您在参加活动前仔细阅读以下内容，确认后方可进入活动页面。 ")], -1);
});
var _hoisted_3 = {
  class: "notice-floor"
};
var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("h4", null, "一、活动要求", -1);
});
var _hoisted_5 = {
  class: "content"
};
var _hoisted_6 = {
  class: "info-order-list"
};
var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("li", null, " 请使用本人账号登录并参加活动，不得代替他人参与或委托他人代为参与。 ", -1);
});
var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("li", null, " 活动开始后，请确保网络环境稳定，并保持设备正常运行。如因个人设备、网络异常或其他非平台原因导致活动中断，相关责任由参与者自行承担。 ", -1);
});
var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("li", null, " 活动过程中，请遵守活动规则及相关要求，不得实施任何影响活动公平、公正的行为。 ", -1);
});
var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("li", null, " 如活动设置了答题时长，请合理安排时间，并在规定时间内完成作答及提交，提交后不可修改。 ", -1);
});
var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("li", null, " 活动结束、时间截止或系统自动交卷后，未提交内容将按照系统实际记录结果进行处理。 ", -1);
});
var _hoisted_12 = /*#__PURE__*/_createStaticVNode("<h4 data-v-fe682536>二、成绩与结果</h4><div class=\"content\" data-v-fe682536><ol class=\"info-order-list\" data-v-fe682536><li data-v-fe682536>活动成绩以活动主办方最终公布为准。</li><li data-v-fe682536> 如活动设置证书、奖项、晋级资格或其他权益，将由活动主办方依据活动规则及成绩结果进行评定。 </li><li data-v-fe682536> 因填写信息错误导致无法发放证书、奖项或相关权益的，由参与者自行承担责任。 </li></ol></div><h4 data-v-fe682536>三、违规说明</h4><div class=\"content\" data-v-fe682536><p data-v-fe682536>出现以下情况之一，主办方有权取消活动成绩、参赛资格或相关权益：</p><ol class=\"info-order-list\" data-v-fe682536><li data-v-fe682536>使用非本人身份参与活动；</li><li data-v-fe682536>通过技术手段、外挂程序或其他不正当方式获取成绩；</li><li data-v-fe682536>抄袭、协助他人作弊或实施其他违规行为；</li><li data-v-fe682536>违反活动规则及主办方相关规定的其他情形。</li></ol></div><h4 data-v-fe682536>四、特别说明</h4><div class=\"content\" data-v-fe682536><ol class=\"info-order-list\" data-v-fe682536><li data-v-fe682536> 活动过程中请勿随意关闭浏览器、刷新页面或退出系统，以免影响活动正常进行。 </li><li data-v-fe682536>如遇系统异常，请及时联系工作人员处理。</li><li data-v-fe682536>主办方保留对活动规则、成绩认定及相关事项的最终解释权。</li></ol></div><div class=\"content\" data-v-fe682536><p data-v-fe682536> 点击【开始答题】即表示您已充分阅读、理解并接受上述内容及本活动相关规则。 </p></div>", 7);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("section", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createElementVNode("ol", _hoisted_6, [_createElementVNode("li", null, _toDisplayString(_ctx.data.answerRule), 1), _hoisted_7, _hoisted_8, _hoisted_9, _hoisted_10, _hoisted_11])]), _hoisted_12])]);
}